// src/app/modules/apps/ticket/components/ticket-list/table/Table.tsx

import {useMemo} from 'react'
import {useTable, ColumnInstance, Row} from 'react-table'
import {CustomHeaderColumn} from './columns/CustomHeaderColumn'
import {CustomRow} from './columns/CustomRow'
import {useQueryResponseData, useQueryResponseLoading, useQueryResponse} from '../core/QueryResponseProvider'
import {Columns} from './columns/_columns'
import {Data} from '../core/_models'
import {ListLoading} from '../components/loading/ListLoading'
import {ListPagination} from '../components/pagination/ListPagination'
import {KTCardBody} from '../../../../../../../_metronic/helpers'
import {useQueryRequest} from '../core/QueryRequestProvider'

const DataTable = () => {
  const data = useQueryResponseData()
  const isLoading = useQueryResponseLoading()
  const {response} = useQueryResponse()
  const {state} = useQueryRequest()
  
  const isFiltered = state.search && state.search.trim().length > 0
  
  const tableData = useMemo(() => data, [data])
  const tableColumns = useMemo(() => Columns, [])
  
  const {getTableProps, getTableBodyProps, headers, rows, prepareRow} = useTable({
    columns: tableColumns,
    data: tableData,
  })

  return (
    <KTCardBody className='py-0 px-0'>
      {isFiltered && (
        <div className='alert alert-info d-flex align-items-center p-4 mb-4'>
          <i className='fas fa-info-circle me-3'></i>
          <div>
            <h6 className='mb-1'>Search Results</h6>
            <p className='mb-0 text-muted'>
              Found {data.length} results matching "{state.search}".
            </p>
          </div>
        </div>
      )}
      
      <div className='table-responsive'>
        <table
          id='ticket_table'
          className='table align-middle table-row-dashed fs-8 gy-5 no-footer'
          {...getTableProps()}
        >
          <thead>
            <tr className='table-header-elegant text-start fw-bolder fs-8 text-uppercase gs-0'>
              {headers.map((column: ColumnInstance<Data>) => (
                <CustomHeaderColumn key={column.id} column={column} />
              ))}
            </tr>
          </thead>
          <tbody className='text-gray-600 fw-bold' {...getTableBodyProps()}>
            {rows.length > 0 ? (
              rows.map((row: Row<Data>, i) => {
                prepareRow(row)
                return <CustomRow row={row} key={`row-${i}-${row.id}`} />
              })
            ) : (
              <tr>
                <td colSpan={Columns.length}>
                  <div className='d-flex text-center w-100 align-content-center justify-content-center py-10'>
                    <div className='text-center'>
                      <i className='fas fa-search fa-3x text-gray-300 mb-3'></i>
                      <h5 className='text-gray-400'>
                        {isFiltered ? 'No results found' : 'No matching records found'}
                      </h5>
                      <p className='text-gray-400'>
                        {isFiltered 
                          ? 'Try adjusting your search criteria' 
                          : 'Try adjusting your search or filters'
                        }
                      </p>
                    </div>
                  </div>
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
      <ListPagination />
      {isLoading && <ListLoading />}
    </KTCardBody>
  )
}

export {DataTable}